import { getErrorMessage } from '../utils/commonUtils';
import {
    useGetAthenaOrderListMutation,
    useGetAthenaOrderNDCWhiteListMutation,
    useSearchAthenaOrdersMutation,
    useUpsertAthenaOrderMasterMutation,
    useUpsertAthenaOrderNDCWhiteListMutation,
    useDeleteAthenaOrderNDCWhiteListMutation
} from '../redux/ndcWhitelistSetup/ndcWhitelistSetupApiSlice';

const useNdcWhitelistSetup = () => {
    const [getAthenaOrderList, { isLoading: getAthenaOrderListLoading }] = useGetAthenaOrderListMutation();
    const [getAthenaOrderNDCWhiteList, { isLoading: getAthenaOrderNDCWhiteListLoading }] = useGetAthenaOrderNDCWhiteListMutation();
    const [searchAthenaOrders, { isLoading: searchAthenaOrdersLoading }] = useSearchAthenaOrdersMutation();
    const [upsertAthenaOrderMaster, { isLoading: upsertAthenaOrderMasterLoading }] = useUpsertAthenaOrderMasterMutation();
    const [upsertAthenaOrderNDCWhiteList, { isLoading: upsertAthenaOrderNDCWhiteListLoading }] = useUpsertAthenaOrderNDCWhiteListMutation();
    const [deleteAthenaOrderNDCWhiteList, { isLoading: deleteAthenaOrderNDCWhiteListLoading }] = useDeleteAthenaOrderNDCWhiteListMutation();

    const getAthenaOrderListAPI = async (data: any) => {
        try {
            const response = await getAthenaOrderList(data).unwrap();
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const getAthenaOrderNDCWhiteListAPI = async (data: any) => {
        try {
            const response = await getAthenaOrderNDCWhiteList(data).unwrap();
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const searchAthenaOrdersAPI = async (data: any) => {
        try {
            const response = await searchAthenaOrders(data).unwrap();
            return response.result;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const upsertAthenaOrderMasterAPI = async (data: any) => {
        try {
            const response = await upsertAthenaOrderMaster(data).unwrap();
            return response;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const upsertAthenaOrderNDCWhiteListAPI = async (data: any) => {
        try {
            const response = await upsertAthenaOrderNDCWhiteList(data).unwrap();
            return response;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    const deleteAthenaOrderNDCWhiteListAPI = async (id: string) => {
        try {
            const response = await deleteAthenaOrderNDCWhiteList(id).unwrap();
            return response;
        } catch (err: any) {
            const message = getErrorMessage(err);
            throw new Error(message);
        }
    };

    return {
        getAthenaOrderListAPI,
        getAthenaOrderListLoading,
        getAthenaOrderNDCWhiteListAPI,
        getAthenaOrderNDCWhiteListLoading,
        searchAthenaOrdersAPI,
        searchAthenaOrdersLoading,
        upsertAthenaOrderMasterAPI,
        upsertAthenaOrderMasterLoading,
        upsertAthenaOrderNDCWhiteListAPI,
        upsertAthenaOrderNDCWhiteListLoading,
        deleteAthenaOrderNDCWhiteListAPI,
        deleteAthenaOrderNDCWhiteListLoading,
    };
}

export default useNdcWhitelistSetup;
